export default __webpack_public_path__ + "static/media/4eB.c45213cb.png";